import React, { Component } from 'react';
import './App.css';

import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Link as RouteLink } from 'react-router-dom';

import Biography from './components/sections/Biography';
import Books from './components/sections/Books';
import Research from './components/sections/research/Research';
import Media from './components/sections/media/Media';
import Twitter from './components/sections/Twitter';
import Footer from './components/sections/Footer';

import Divider from './components/sections/divider/Divider';

import data from './components/data/data.json';

class App extends Component {

  constructor() {
    super();
    this.state = data;
  }

  render() {
    return (
      <Router basename='/calvo'>
      <div className="App" style={appStyle}>
  
        <Divider/>

        <Biography />

        <Books />

        <Research research={this.state.research} />

        <Media media={this.state.media} />

        <Twitter />

        <Footer />

        <Divider />

      </div>
      </Router>
    );
  }
 
}

const appStyle={
  display: "flex",
  flexDirection: "column",
  maxWidth: '2000px',
  overflow: 'hidden'
}

export default App;
